import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(portfolio)/_layout/ContactModal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(portfolio)/_layout/Footer/Footer.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(portfolio)/_layout/Navigation.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(portfolio)/skills/_components/Skill.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(portfolio)/skills/_components/SkillsNav.tsx");
